/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Cta_TitleInputs */

const es_home_cta_title = /** @type {(inputs: Home_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No es búsqueda. Es inteligencia.`)
};

const en_home_cta_title = /** @type {(inputs: Home_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It's not search. It's intelligence.`)
};

/**
* | output |
* | --- |
* | "It's not search. It's intelligence." |
*
* @param {Home_Cta_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_cta_title = /** @type {((inputs?: Home_Cta_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Cta_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_cta_title(inputs)
	return en_home_cta_title(inputs)
});
export { home_cta_title as "home.cta.title" }